import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormControl} from "@angular/forms";
import {MatMenuTrigger} from "@angular/material/menu";
import {Subscription} from "rxjs";
import {animate, style, transition, trigger} from "@angular/animations";

@Component({
	selector: 'app-popup-text-input',
	standalone: false,
	templateUrl: './popup-text-input.component.html',
	styleUrl: './popup-text-input.component.scss',
	animations: [
		trigger('validators-appear', [
			transition(':enter', [
				style({opacity: 0, display: 'none', transform: 'translateY(-10px)'}),
				animate('300ms ease-in-out', style({opacity: 1, display: 'block', transform: 'translateY(0)'})),
			])
		])
	]
})
export class PopupTextInputComponent {
	@Input() control: FormControl;
	@Input() loading: boolean = false;
	@Input() warning: string | undefined;
	@Input() disabled: boolean = false;

	@Output() confirm = new EventEmitter<void>();
	@Output() close = new EventEmitter<void>();

	@ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
	@ViewChild('triggerContainer') triggerContainer: ElementRef;

	subscription: Subscription = new Subscription();

	onConfirm(): void {
		if (this.control.valid) {
			this.confirm.emit();
			this.menuTrigger.closeMenu();
		}
	}

	onClose(): void {
		this.close.emit();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
